import React from "react";
// import Navbar from "./Navbar";
// import Footer from "./Footer";
import "../CSS/Privacy.css";
// import "./GlobalStyles.css";

const PrivacyPolicy = () => {
  //   useEffect(() => {
  //     // Google Tag Manager script
  //     const script = document.createElement("script");
  //     script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  //     new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  //     j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  //     'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  //     })(window,document,'script','dataLayer','GTM-NVPCHVFQ');`;
  //     document.head.appendChild(script);
  //   }, []);

  return (
    <>

      {/* Page Header */}
      <section className="po-page-header">
        <div className="po-container">
          <h1>Privacy Policy</h1>
          <p>
            Last Updated: 11/06/2025 | Effective for: Contributors, Filmmakers,
            Talent/Technicians
          </p>
        </div>
      </section>

      {/* Policy Content */}
      <section className="po-policy-content">
        <div className="po-container">
          {/* Section 1 */}
          <div className="po-policy-section">
            <h2>1. Information We Collect</h2>
            <h3>For All Users:</h3>
            <ul>
              <li>
                <strong>Personal Data:</strong> Name, email, phone, address,
                PAN/GST (for payouts).
              </li>
              <li>
                <strong>Professional Data:</strong> (Filmmakers/Talent)
                Portfolio, credentials, bank details.
              </li>
              <li>
                <strong>Financial Data:</strong> (Contributors) Contribution
                amount, payment method (via secure gateways).
              </li>
              <li>
                <strong>Technical Data:</strong> IP address, device type,
                cookies (see Section 4).
              </li>
            </ul>
            <h3>Special Categories:</h3>
            <ul>
              <li>
                <strong>Sensitive Data:</strong> Govt. IDs (for KYC) -- stored
                encrypted, used only for compliance.
              </li>
            </ul>
          </div>

          {/* Section 2 */}
          <div className="po-policy-section">
            <h2>2. How We Use Your Data</h2>
            <table className="po-policy-table">
              <thead>
                <tr>
                  <th>Purpose</th>
                  <th>Legal Basis</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Facilitate contributions/projects</td>
                  <td>Contractual necessity</td>
                </tr>
                <tr>
                  <td>Profit-sharing calculations</td>
                  <td>Legitimate business interest</td>
                </tr>
                <tr>
                  <td>Marketing (e.g., new projects)</td>
                  <td>Consent (opt-in required)</td>
                </tr>
                <tr>
                  <td>Compliance (tax/fraud checks)</td>
                  <td>Legal obligation</td>
                </tr>
              </tbody>
            </table>

            <h3>For Filmmakers/Talent:</h3>
            <ul>
              <li>Profile display on Cinevestor platform.</li>
              <li>Payment processing for services.</li>
            </ul>
          </div>

          {/* Section 3 */}
          <div className="po-policy-section">
            <h2>3. Data Sharing & Disclosure</h2>
            <ul>
              <li>
                <strong>With Filmmaker Teams:</strong> Contributor contact
                details (only for project updates).
              </li>
              <li>
                <strong>Third Parties:</strong>
                <ul>
                  <li>Payment processors (Razorpay/Stripe).</li>
                  <li>
                    Analytics (Google Analytics -- anonymized data).
                  </li>
                </ul>
              </li>
              <li>
                <strong>Legal Disclosures:</strong> If required by
                courts/law enforcement.
              </li>
            </ul>
            <div className="po-highlight-box">
              <p>
                <strong>No sale of data</strong> to advertisers.
              </p>
            </div>
          </div>

          {/* Section 4 */}
          <div className="po-policy-section">
            <h2>4. Cookies & Tracking</h2>
            <ul>
              <li>
                <strong>Essential Cookies:</strong> Login sessions, security.
              </li>
              <li>
                <strong>Analytical Cookies:</strong> Page visits, demographics
                (opt-out via browser settings).
              </li>
              <li>
                <strong>Marketing Cookies:</strong> Retargeting ads (disabled by
                default).
              </li>
            </ul>
          </div>

          {/* Section 5 */}
          <div className="po-policy-section">
            <h2>5. User Rights</h2>
            <p>
              <strong>You Can:</strong>
            </p>
            <ul>
              <li>Access/correct your data via dashboard.</li>
              <li>Request deletion (except legal/financial records).</li>
              <li>
                Withdraw marketing consent (via{" "}
                <a href="mailto:unsubscribe@cinevestor.in" style={{ color: "var(--accent-1)" }}>
                  [unsubscribe]
                </a>{" "}
                link).
              </li>
              <li>
                Port data (ask at{" "}
                <a
                  href="mailto:dpo@cinevestor.in"
                  style={{ color: "var(--accent-1)" }}
                >
                  dpo@cinevestor.in
                </a>
                ).
              </li>
            </ul>
            <div className="po-highlight-box">
              <p>
                <strong>Response Time:</strong> 30 days.
              </p>
            </div>
          </div>

          {/* Section 6 */}
          <div className="po-policy-section">
            <h2>6. Data Security</h2>
            <ul>
              <li>
                <strong>Encryption:</strong> AES-256 for sensitive data.
              </li>
              <li>
                <strong>Access Controls:</strong> Role-based permissions.
              </li>
              <li>
                <strong>Breach Protocol:</strong> 72-hour notification to
                users/regulators.
              </li>
            </ul>
          </div>

          {/* Section 7 */}
          <div className="po-policy-section">
            <h2>7. Retention Period</h2>
            <table className="po-policy-table">
              <thead>
                <tr>
                  <th>Data Type</th>
                  <th>Retention Period</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Financial records</td>
                  <td>7 years (tax compliance)</td>
                </tr>
                <tr>
                  <td>User profiles</td>
                  <td>3 years post-inactivity</td>
                </tr>
                <tr>
                  <td>Marketing consents</td>
                  <td>Until revoked</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Section 8 */}
          <div className="po-policy-section">
            <h2>8. Children's Privacy</h2>
            <ul>
              <li>
                <strong>Strictly 18+:</strong> No data collected from minors.
              </li>
            </ul>
          </div>

          {/* Section 9 */}
          <div className="po-policy-section">
            <h2>9. Updates & Grievances</h2>
            <ul>
              <li>
                Policy changes notified via email/dashboard.
              </li>
              <li>
                Complaints to:
                <br />
                <strong>Grievance Officer:</strong> [Name]
                <br />
                <strong>Email:</strong>{" "}
                <a
                  href="mailto:dpo@cinevestor.in"
                  style={{ color: "var(--accent-1)" }}
                >
                  dpo@cinevestor.in
                </a>
                <br />
                <strong>Address:</strong> [Registered Office]
              </li>
            </ul>
          </div>

          {/* Section 10 */}
          <div className="po-policy-section">
            <h2>10. Jurisdiction</h2>
            <ul>
              <li>
                Governed by <strong>Indian law</strong> (IT Act, 2000 + PDPB
                2023-ready).
              </li>
              <li>
                Disputes in <strong>Gondia, Maharashtra courts</strong>.
              </li>
            </ul>
          </div>

          {/* Closing Section */}
          <div className="po-policy-section">
            <div className="po-highlight-box">
              <p>
                <strong>
                  By using Cinevestor.in, you agree to this policy.
                </strong>
              </p>
            </div>
            <p className="po-company-info">
              <strong> 2024 Vithal Visions Private Limited</strong>
              <br />
              CIN: U59141PN2025PTC237150 | GSTIN: 27AAKCV6810E1Z9
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
